import './index.less';

import { Button, Form, InputNumber, message, Modal } from 'antd';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ApplicationStatusEnum } from '../../../enum/applicationStepStatus';
import { Application } from '../../../features/application/applicationSlice';
import { AppDispatch, RootState } from '../../../store/store';
import { updateApplicationInterestRateThunk } from '../../../services/applicationService/applicationThunk';

type UpdateInterestRateModalProps = {
  applicationDetails?: Application;
  callback?: () => void;
};

const UpdateInterestRateModal: React.FC<UpdateInterestRateModalProps> = (props) => {
  const { applicationDetails, callback } = props;
  const dispatch = useDispatch<AppDispatch>();

  const [form] = Form.useForm();
  const { currentUser } = useSelector((state: RootState) => state.user);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setLoading(false);
    form.resetFields();
  };

  const onFinish = async () => {
    await form
      .validateFields()
      .then(async (values) => {
        setLoading(true);

        const payload = {
          interestRate: values.interestRate,
          updatedBy: currentUser?.data?.username,
        };

        await dispatch(
          updateApplicationInterestRateThunk({
            applicationId: applicationDetails?.id,
            payload,
          })
        )
          .unwrap()
          .then(() => {
            if (callback) callback();
            message.success('Interest Rate Updated Successfully');
          });
      })
      .catch((err) => {
        message.error('Something went wrong. Please try again later.');
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Button
        type="primary"
        onClick={showModal}
        disabled={
          applicationDetails?.applicationStatus === ApplicationStatusEnum.APPROVED ||
          applicationDetails?.applicationStatus === ApplicationStatusEnum.REJECTED
        }
        ghost
      >
        Update
      </Button>
      <Modal
        title="Update Interest Rate"
        okText="Confirm"
        open={isModalOpen}
        onOk={onFinish}
        onCancel={handleCancel}
        confirmLoading={loading}
        width={360}
        destroyOnClose
        centered
      >
        <Form
          form={form}
          layout="vertical"
          autoComplete="off"
          requiredMark={false}
          initialValues={{
            interestRate: applicationDetails?.loanInterestRate,
          }}
        >
          <Form.Item
            name="interestRate"
            rules={[{ required: true, message: 'Interest rate is required' }]}
          >
            <InputNumber
              placeholder="Please input"
              style={{ width: '100%' }}
              controls={false}
              inputMode="numeric"
              type={'number'}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default UpdateInterestRateModal;
